import { gql } from "../../../../generated-graphql";

export const WAIT_FOR_ALL_COHORT_REPORT_QUERY = gql(`
  query WaitForAllCohortReport($reportingYear: Int, $search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    waitForAllCohortReport(reportingYear: $reportingYear, search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        cohortId
        cohortName
        organizationName
        state
        cohortType
        cohortSize
        readyCount
        waitingOnCount
        cohortLink
      }
      count
    }
  }
`);

export const EXPORT_WAIT_FOR_ALL_COHORT_REPORT_TO_CSV = gql(`
  mutation ExportWaitForAllCohortReportToCsv($reportingYear: Int) {
    exportWaitForAllCohortReportToCsv(reportingYear: $reportingYear) {
      success
      errorMsg
      downloadUrl
    }
  }
`);
